import { Api } from '../api';
import { profile } from '../endpoints';
import type { ApiResponse } from '../../models';
import type { UsersFeaturesResponse, UsersResponse } from '../users';

export class ProfileApi extends Api {
  static getProfile = async (signal?: AbortSignal) => {
    const res = await this.get<ApiResponse<UsersResponse>>({ url: profile.getProfile(), signal });
    return res.data;
  };

  static getProfileFeatures = async (signal?: AbortSignal) => {
    const res = await this.get<ApiResponse<UsersFeaturesResponse>>({ url: profile.getProfileFeatures(), signal });
    return res.data;
  };
}
